<template>
  <div class="module-margin">
    <HeadNav></HeadNav>
    <div class="func-wrap">
      <van-skeleton :row="7" :loading="isSkeleton">
        <div v-for="item in list" :key="item.ID" class="module-info">
          <div class="module-title">{{ item.Name }}</div>
          <ul class="module-list">
            <li
              v-for="apps in item.applications"
              :key="apps.ID"
              @click="funcBtn(item,apps)"
              class="module-apps"
            >
              <div class="module-apps-func">
                <div>
                  <img :src="require('@/assets/moduleIcon/'+apps.Icon)" alt />
                </div>
                <div class="module-apps-names">{{ apps.Name }}</div>
              </div>
            </li>
          </ul>
        </div>
      </van-skeleton>
    </div>
  </div>
</template>
<script>
  import HeadNav from "@/pages/common/views/components/headnav/HeadNav.vue";
  export default {
    name: "funclist",
    components: {
      HeadNav
    },
    data() {
      return {
        isSkeleton: true,
        list: [],
        domainList:[],
        xwList:{
          ID: 9,
          Icon: "icons-classCard",
          IsDefault: false,
          IsEnabled: true,
          ModuleCode: "inp",
          Name: "电子班牌",
          PCIcon: "icons-classCard",
          SortOrder: 3,
          applications:[
            {
            ID: 309,
            Icon: "icons-jcgl-setting.png",
            IsDefault: true,
            IsEnabled: true,
            IsExternal: true,
            MID: 9,
            MobileUrl: "http://singleapi.xiaoyangedu.com:8082/SingleLoginRedirect/XY03350004/XW",
            Name: "希沃云班",
            PCIcon: "icons-jcgl-setting.png",
            PCIconDirectory: "blue",
            PCMainColor: "rgba(132,104,252,0.1)",
            PCUrl: "http://singleapi.xiaoyangedu.com:8082/SingleLoginRedirect/XY03350004/XW",
            }
          ]
        }
      };
    },
    created() {
      this.getMobileMoudle();
    },
    methods: {
      async getMobileMoudle() {
        this.list = [];
        this.domainList=[];
        this.xy.loading();
        let res = await this.xyapi.get(
          this.xyMApi + "/xy/comm/MobileMoudle"
        );
        let resList = res.data.Modules;
        this.domainList=res.data.ServiceDomains
        // resList.push(this.xwList)
        //debugger
        for (let i = 0, len = resList.length; i < len; i++) {
          if (resList[i].Name !== "家校互通") {
            this.list.push(resList[i]);
          }
        }
        this.isSkeleton = false;
        this.xy.unloading();
      },
      
      funcBtn(pval, vals) { // 移动端
        this.$store.commit('changeApiPath', `${this.xyMApi}/${pval.ModuleCode}`)
        localStorage.setItem("breadcrumb", JSON.stringify(vals));
        if (vals.MobileUrl) {
          // 原有的
          // localStorage.setItem("navTitle", vals.Name);
          // this.$router.push(vals.MobileUrl);
          if (vals.IsExternal) {
            let urls = `${vals.MobileUrl}${
              vals.MobileUrl.indexOf('?') > -1 ? '&' : '?'
            }`
            let tokens = this.xy.getCookie('.XYTOKEN')
            let actumber = this.$store.state.common.actnumber
            window.open(`${urls}token=${tokens}&AccountNumber=${actumber}`)
            return
          }
        } else {
          localStorage.setItem("navTitle", vals.subMenu[0].Name);
          this.$router.push(vals.subMenu[0].ApplicationSubMenuMobileUrl);
        }
        this.$store.commit("common/getMenuIDs", [vals.MID, vals.ID]);
      }
    }
  };
</script>
<style lang="less" scoped>
  .module-margin {
    .func-wrap {
      margin-top: 100px;
    }
    .module-info {
      margin: 20px;
      padding: 20px;
      background: #ffffff;
      .module-list {
        display: flex;
        flex-wrap: wrap;
      }
      .module-title {
        border-left: 8px solid #4196ff;
        padding-left: 10px;
        font-weight: bold;
        font-size: 28px;
        margin-bottom: 40px;
      }

      .module-apps {
        // margin: 30px 0 0 20px;
        width: 25%;
        margin-bottom: 40px;
        .module-apps-func {
          font-size: 26px;
          // display: flex;
          // align-items: center;
          text-align: center;
          div {
            // width: 80px;
            // text-align: left;
            img {
              width: 60px;
            }
          }
          .module-apps-names {
            margin-top: 10px;
          }
        }
      }
    }
  }
</style>
